import md5 from 'js-md5';
import { localizedProviderTitleId, localeService } from '../../core/helpers';
export const hasDayPass = (user) => {
    if (!user.dayPassEndDate) {
        return false;
    }
    return new Date(user.dayPassEndDate).getTime() > Date.now();
};
export const getDisplayName = (user) => {
    if (!Boolean(user.id)) {
        return '';
    }
    const title = user.title &&
        localeService.formatMessageById(localizedProviderTitleId(user.title));
    const lastNameWithTitle = !['', 'Other'].includes(user.title)
        ? `${title} ${user.lastName}`
        : `${user.lastName}`;
    return Boolean(user.displayName) && user.displayName !== ''
        ? user.displayName
        : lastNameWithTitle;
};
const gravatarIdCache = {};
export const getProfilePictureUrl = ({ user, size = 64, }) => {
    if (!user.useProfilePicture) {
        return null;
    }
    const defaultImage = '/assets/icons/legacy/avatar.svg';
    let url = '';
    switch (user.profilePictureProvider) {
        case 'doxymeProfilePicture':
        case 'LinkedIn':
            url = user.userProfilePictureUrl ?? defaultImage;
            // Remove any existing timestamp from URL to get clean URL
            const cleanUrl = url.split('?')[0];
            // If URL already has a timestamp, use it as-is (from Redux after upload)
            if (!url.includes('?')) {
                // Normalize URL for sessionStorage key matching (remove protocol, trailing slashes)
                const normalizedUrl = cleanUrl.replace(/^https?:\/\//, '').replace(/\/$/, '');
                const storageKey = `avatar_refresh_${normalizedUrl}`;
                // Check if we have a stored timestamp for this URL (one-time after upload)
                const storedTimestamp = sessionStorage.getItem(storageKey);
                if (storedTimestamp) {
                    // Use the stored timestamp to ensure all components use the same URL
                    // This prevents multiple requests (one with timestamp, one without)
                    url = `${cleanUrl}?${storedTimestamp}`;
                    // Clear the timestamp after first page load (use setTimeout to clear after all components have rendered)
                    setTimeout(() => {
                        sessionStorage.removeItem(storageKey);
                    }, 1000);
                }
                else {
                    // Use clean URL for normal browser caching
                    url = cleanUrl;
                }
            }
            break;
        case 'gravatar': {
            const gravatarEmail = gravatarIdCache[user.email];
            const gravatarId = gravatarEmail ?? md5((user.email ?? '').trim().toLowerCase());
            if (!Boolean(gravatarEmail)) {
                gravatarIdCache[user.email] = gravatarId;
            }
            url = Boolean(gravatarId)
                ? `https://www.gravatar.com/avatar/${gravatarId}?s=${size}`
                : defaultImage;
            break;
        }
        default:
            url = defaultImage;
    }
    return url;
};
